import { render, staticRenderFns } from "./AvatarCard.vue?vue&type=template&id=6d62d239&scoped=true"
import script from "./AvatarCard.vue?vue&type=script&lang=js"
export * from "./AvatarCard.vue?vue&type=script&lang=js"
import style0 from "./AvatarCard.vue?vue&type=style&index=0&id=6d62d239&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d62d239",
  null
  
)

export default component.exports